export default class ScaleImage {
	constructor(className = null) {
		if (!gsap || !className) return;

		gsap.utils.toArray(className).forEach((image, i) => {
			image.el = image.querySelector('img');

			image.el && gsap.fromTo(image.el, {
				scale: parseFloat(image.dataset?.scaleFrom) || 1,
			}, {
				scale: parseFloat(image.dataset?.scaleTo) || 1.3,
				ease: "none",
				scrollTrigger: {
					trigger: image,
					start: "top bottom",
					end: "bottom top",
					scrub: 2,
					invalidateOnRefresh: true,
				}
			});
		});
	}
}
